import React from 'react'

const CorporateGroupDetails = () => {
    return (
        <section className="main-container col1-layout">
            <div className="main container">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        {/*<!-- <div className="page-title">
            <div className="heading-counter warning text-center" style={{border: 1px solid #82d783;color: #3c763d;">
              <i className="fa fa-check"></i>
              <span> Your cart subtotal is only <strong>S$79.89</strong> away from free shipping.</span>
              <span> Your cart subtotal is eligible for <strong>free shipping</strong>.</span>
              <span> Your order has been successfully processed!</span>
            </div>
    </div> -->*/}
                        <div className="page-content">
                            {/* <!-- <ul className="step">
              <li><i className="fa fa-shopping-basket"></i><span> Cart</span></li>
              <li><i className="fa fa-map-marker"></i><span> Shipping</span></li>
              <li className="current-step"><i className="fa fa-clipboard"></i><span> Info</span></li>
</ul> -->*/}
                            <div className="page-content checkout-page">
                                <div className="box-border">
                                    <h2>Approval Group Details</h2>
                                    <div className="col2-set">
                                        <div className="col-1">
                                            <h3 className="checkout-sep" style={{ paddingBottom: "0" }}>RS1</h3>
                                            <h5><strong>Description:</strong> Stationary Approval Group</h5>
                                        </div>
                                        {/*<!-- <div className="col-2">
                    <h3 className="checkout-sep" style={{padding-bottom: 0;"></h3>
                    <h5><strong>Last Name:</strong> Chong</h5>
                    <h5><strong>Status:</strong> Verified</h5>
                    <h5><strong>Login ID</strong> alexchong</h5>
                    <h5></h5><br>
                    <h5></h5><br>
                  </div> -->*/}
                                    </div>
                                    {/*<!-- <a href="#">Reset Password</a> -->*/}
                                    <hr />
                                    <div className="box-account" style={{
                                        display: "flow-root"
                                    }}>
                                        <div className="page-title">
                                            < h2 > Staff Listing</h2>
                                        </div>
                                        <div className="dashboard">
                                            {/*<!-- <div className="welcome-msg"> <h4>Hello, Pranali Deshmukh!</h4>
                          <p>From your Dashboard you have the ability to view a snapshot of your recent account activity and update your account information. Select a link below to view or edit information.</p>
                </div> -->*/}
                                            <div className="toolbar">
                                                <div className="row">
                                                    <div className="col-md-3 col-sm-3" style={{
                                                        display: "flex"
                                                    }}>
                                                        <input className="input form-control" type="search" name="" id="first_name_1"
                                                            placeholder="Keywords search..." style={{ borderRadius: "3px 0 0 3px", margin: '0' }} />
                                                        <button type="submit" style={{ border: "1px solid #ccc", borderRadius: "0 3px 3px 0" }}>
                                                            <i className="fa fa-search"></i></button>
                                                        {/*<!-- <div className="btn-group">
                                                  <div id="grid-view" className="btn btn-default active" data-toggle="tooltip" title="" data-original-title="Grid"><a href="shop_grid.html"><i className="fa fa-th"></i></a></div>
                                                  <div id="list-view" className="btn btn-default" data-toggle="tooltip" title="" data-original-title="List"><a href="shop_list.html"><i className="fa fa-th-list"></i></a></div>
                                                </div> -->*/}
                                                        {/*<!-- <a href="compare.html" id="compare-total">Product Compare (3)</a> -->*/}
                                                    </div>
                                                    <div className="col-sm-2 text-right sort-by">
                                                        {/*<!-- <label className="control-label" for="input-sort">Filter By Cost Center:</label> -->*/}
                                                    </div>
                                                    <div className="col-md-3 col-sm-2 text-right">
                                                        {/*<!-- <select id="input-sort" className="form-control col-sm-3">
                              <option value="" selected="selected">Default</option>
                              <option value="">Name (A - Z)</option>
                              <option value="">Name (Z - A)</option>
                              <option value="">Price (Low &gt; High)</option>
                              <option value="">Price (High &gt; Low)</option>
                              <option value="">Rating (Highest)</option>
                              <option value="">Rating (Lowest)</option>
                              <option value="">Model (A - Z)</option>
                              <option value="">Model (Z - A)</option>
                                            </select> -->*/}
                                                    </div>
                                                    {/*<!-- <div className="col-sm-1 text-right show-limit">
                            <label className="control-label" for="input-limit">Approval:</label>
                                            </div> -->*/}
                                                    <div className="col-sm-1 text-right">
                                                        {/*<!-- <select id="input-limit" className="form-control">
                                                  <option value="" selected="selected">Approval</option>
                                                  <option value="">Backup Approval</option>
                                        </select> -->*/}
                                                    </div>
                                                    <div className="col-sm-3 text-right">
                                                        <a href="#">+ Add New Staff </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="recent-orders">
                                                {/*<!-- <div className="title-buttons"><strong></strong>
                                        <a href="#">+ Create New Order </a> </div> -->*/}
                                                <div className="table-responsive">
                                                    <table className="data-table" id="my-orders-table">
                                                        <thead>
                                                            <tr className="first last">
                                                                <th>Staff ID</th>
                                                                <th>Staff Name</th>
                                                                <th>Role</th>
                                                                <th>Group</th>
                                                                <th>Status</th>
                                                                <th>&nbsp;</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="first odd">
                                                                <td>P1</td>
                                                                <td>Alex Chong</td>
                                                                <td>Requestor</td>
                                                                <td>Stationary Approval Group</td>
                                                                <td><em>Verified</em></td>
                                                                <td className="a-center last"><span className="nobr"> <a href="#">Delete</a> <span className="separator">|</span> <a href="#">Edit</a> </span></td>
                                                            </tr>
                                                            <tr className="last even">
                                                                <td>P2</td>
                                                                <td>Ashley Chua</td>
                                                                <td>L1 Approval</td>
                                                                <td>Stationary Approval Group</td>
                                                                <td><em>Verified</em></td>
                                                                <td className="a-center last"><span className="nobr"> <a href="#">Delete</a> <span className="separator">|</span> <a href="#">Edit</a> </span></td>
                                                            </tr>
                                                            <tr className="first odd">
                                                                <td>P3</td>
                                                                <td>Eric Tan</td>
                                                                <td>L2 Approval</td>
                                                                <td>Stationary Approval Group</td>
                                                                <td><em>Verified</em></td>
                                                                <td className="a-center last"><span className="nobr"> <a href="#">Delete</a> <span className="separator">|</span> <a href="#">Edit</a> </span></td>
                                                            </tr>
                                                            <tr className="last even">
                                                                <td>P4</td>
                                                                <td>Carol Sy</td>
                                                                <td>L3 Approval</td>
                                                                <td>Stationary Approval Group</td>
                                                                <td><em>Verified</em></td>
                                                                <td className="a-center last"><span className="nobr"> <a href="#">Delete</a> <span className="separator">|</span> <a href="#">Edit</a> </span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <hr />
                                            {/*<!-- <h3 className="checkout-sep">Guest Checkout</h3> -->*/}
                                            <div className="cart_navigation">
                                                {/*<!-- <button className="button continue-shopping" title="Continue shopping" type="button"><span>Previous</span></button> -->*/}
                                                <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button"><span>Back to Group Listing</span></button>
                                                {/*<!-- <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button" style={{
                                                      margin-right: 10px;
                                                      background: #337ab7;
                                                      border: 0px solid #337ab7;
                                    "><span>Submit for Approval</span></button> -->*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div >
                    </div>
                </div>
            </div>
        </section >
    )
}

export default CorporateGroupDetails